const types = {
  CHOICE: 'choice',
  SELECT: 'select',
  RANDOM: 'random',
};

export default types;
